import { render, staticRenderFns } from "./ConfirmationPopUp.vue?vue&type=template&id=48131916&scoped=true"
import script from "./ConfirmationPopUp.vue?vue&type=script&lang=js"
export * from "./ConfirmationPopUp.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationPopUp.vue?vue&type=style&index=0&id=48131916&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48131916",
  null
  
)

export default component.exports